import { TFunction } from "i18next";
import * as yup from "yup";
import { SchemaOf } from "yup";

interface AddAgentValidationProps {
  name?: string;
  mobilNo?: string;
  mobilNoAgain?: string;
}

export const AddAgentValidationSchema = (
  t: TFunction
): SchemaOf<AddAgentValidationProps> =>
  yup.object().shape({
    name: yup.string().required(t("name_surname_validation").toString()),
    mobilNo: yup
      .string()
      .required(t("phone_number_required_validation").toString()),
    mobilNoAgain: yup
      .string()
      .oneOf([yup.ref("mobilNo"), null], t("phone_match_valid").toString())
      .required(t("phone_repeat_validation").toString()),
  });

interface EditAgentValidationProps {
  name?: string;
  mobilNo?: string;
}
export const editAgentValidationSchema = (
  t: TFunction
): SchemaOf<EditAgentValidationProps> =>
  yup.object().shape({
    name: yup.string().required(t("name_surname_validation").toString()),
    mobilNo: yup
      .string()
      .required(t("phone_number_required_validation").toString()),
  });
